import { QueryClient, QueryMeta } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import React, { ReactNode } from 'react';

import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';

declare module '@tanstack/query-core' {
  interface QueryMeta {
    persist?: boolean;
  }
}

const persister = createAsyncStoragePersister({
  storage: window.localStorage,
  key: 'rq:persist',
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: false,
      retry: false,
    },
  },
});

export const AppQueryClientProvider = ({
  children,
}: {
  children: ReactNode;
}) => (
  <PersistQueryClientProvider
    client={queryClient}
    persistOptions={{
      persister,
      dehydrateOptions: {
        shouldDehydrateQuery: (query: any) =>
          (query.meta as QueryMeta | undefined)?.persist === true,
      },
    }}
  >
    {children}
  </PersistQueryClientProvider>
);
